/* src/app/timeline-skip/partials/timeline-skip-toolbar/timeline-skip-toolbar.component.scss */
.datePicker {
  display: inline-block;
  position: absolute;
  left: 42rem;
  top: 7rem;
}
.timelineToolbarContainer {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
  padding-left: 15rem;
  position: fixed;
  z-index: 102;
}
.dateSelectorContainer {
  display: flex;
  flex-flow: row wrap;
}
.dateSelectorContainer button {
  background: transparent;
  border: 0;
  box-shadow: none;
}
.dateSelectorContainer i {
  font-size: 2rem;
}
.dateSelectorContainer i:hover {
  color: #2196f3;
  cursor: pointer;
}
.dateSelectorContainer .dateSelectorBox {
  background-color: transparent;
  padding: 0.3rem;
  width: 20rem;
  font-size: 1.2rem;
  text-align: center;
  margin-top: 0.7rem;
  color: #34495e;
  font-weight: bold;
}
.dateSelectorContainer .dateSelectorBox:hover {
  color: #2196f3;
  cursor: pointer;
}
.vehicleTypeSelector {
  width: 11rem;
}
/*# sourceMappingURL=timeline-skip-toolbar.component.css.map */
